import {
    VALIDATION_LEDGER_GET_LIST_ACTION,
    VALIDATION_LEDGER_EXPORT_ACTION,
    VALIDATION_LEDGER_UNSET_EXPORT_ACTION,
    VALIDATION_LEDGER_GET_LOCATION_DETAILS
} from "../../constants/validationLedger"

const initialState = {
    list: [],
    reload: true,
    file: null,
    locationDetails: {}
}

const validationLedgerReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATION_LEDGER_GET_LIST_ACTION:
            return {
                ...state,
                list: action.list
            }
        case VALIDATION_LEDGER_EXPORT_ACTION:
            return {
                ...state,
                file: action.doc
            }
        case VALIDATION_LEDGER_UNSET_EXPORT_ACTION: {
            return {
                ...state,
                file: null
            }
        }
        case VALIDATION_LEDGER_GET_LOCATION_DETAILS: {
            return {
                ...state,
                locationDetails: {
                    ...state.locationDetails,
                    [`${action.jobSiteId}-${action.locationId}`]: action.details
                }
            }
        }
        default: return state
    }
}

export default validationLedgerReducer
